var _title, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAurora = function SvgAurora(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "\u5E01\u79CD-aurora")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5E01\\u79CD-aurora",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "aurora-avatar-grn",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,0 L12,0 C18.625,0 24,5.375 24,12 L24,12 C24,18.625 18.625,24 12,24 L12,24 C5.375,24 0,18.625 0,12 L0,12 C0,5.375 5.375,0 12,0 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#70D44B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,4.9 C12.6333333,4.9 13.2083333,5.25833333 13.4916667,5.825 L18.175,15.2 C18.5833333,16.025 18.25,17.025 17.425,17.4333333 C17.1916667,17.55 16.9416667,17.6083333 16.6833333,17.6083333 L7.31666667,17.6083333 C6.4,17.6083333 5.65,16.8583333 5.65,15.9416667 C5.65,15.6833333 5.70833333,15.425 5.825,15.2 L10.5083333,5.825 C10.7916667,5.25 11.3666667,4.89166667 12,4.9 M12,3.75 C10.9333333,3.75 9.95833333,4.35 9.48333333,5.30833333 L4.8,14.6833333 C4.10833333,16.075 4.66666667,17.7583333 6.05833333,18.4583333 C6.45,18.65 6.88333333,18.7583333 7.31666667,18.7583333 L16.6916667,18.7583333 C18.2416667,18.7583333 19.5083333,17.5 19.5083333,15.95 C19.5083333,15.5166667 19.4083333,15.0833333 19.2083333,14.6916667 L14.5166667,5.30833333 C14.0416667,4.35 13.0666667,3.75 12,3.75 Z",
    id: "\\u5F62\\u72B6",
    fill: "#FFFFFF"
  })))));
};

export { SvgAurora as ReactComponent };
export default __webpack_public_path__ + "39ba25a7140016606ef65880617df82b.svg";